import React, { useEffect, useRef } from 'react';
import ProfileSettings from '@Services/ProfileSettings';

export default function WithCombinedInfoComponent({ loaded, WrappedComponent, ...props }) {
  const loadedRef = useRef(loaded);
  const propsRef = useRef(props);

  useEffect(() => {
    loadedRef.current = loaded;
    propsRef.current = props;
  });

  useEffect(() => {
    let isMounted = true;

    const loadCombinedInfo = async () => {
      const combinedInfo = await ProfileSettings.loadCombineInfo();

      if (isMounted) {
        loadedRef.current(propsRef.current, combinedInfo);
      }
    };

    loadCombinedInfo();

    return () => {
      isMounted = false;
    };
  }, []);

  return <WrappedComponent {...props} />;
}
